import angular from 'angular';

import * as actions from '../../store/actions';

const mapStateToScope = (state) => ({
  records: state.user.users,
  subComponent: state.statsbar.activeComponent,
});

angular.module('myConsultApp').directive('transactionRow', ($ngRedux, $http, ENV, $timeout) => {
  return {
    scope: {
      recordData: '=',
      expandedStatus: '=',
    },
    templateUrl: 'templates/v2/transaction-row.html',
    restrict: 'E',
    link: ($scope, elem) => {
      $scope.shouldBeExpanded = false;
      $scope.transactionId =
        $scope.recordData?.transaction_id ||
        $scope.recordData?.transaction.id ||
        $scope.recordData?.id;
      $scope.record = {};
      $scope.unsubscribe = $ngRedux.connect(mapStateToScope, actions)($scope);

      const expandedStatusListerner = $scope.$watch('expandedStatus', (newVal, oldVal) => {
        $scope.shouldBeExpanded =
          newVal || oldVal ? !$scope.shouldBeExpanded : $scope.shouldBeExpanded;
        if ($scope.shouldBeExpanded && !$scope.record?.transaction) {
          $scope.getTransaction($http, ENV, $scope.transactionId).then((response) => {
            $timeout(() => {
              $scope.record.transaction = response;
            });
          });
        }
      });

      $scope.$on('destroy', () => {
        expandedStatusListerner();
      });
    },
  };
});
